<template>
  <h1>Contact</h1>
</template>

<script setup lang="ts"></script>

<style lang="postcss" scoped></style>
